const AuthFailed = () => (
  <div className="loading-page-container">
    <wb-text>
      Authentication failed. Please try to login OnTLL system again.
    </wb-text>
  </div>
);

export default AuthFailed;
